import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {SectionStatusService} from "../section-status.service";
import {Sections, SectionStates, SectionStatus} from "../model/section-status";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {NGXLogger} from "ngx-logger";
import {CoreService} from "../../shared/services/core.service";
import {takeUntil, map, tap} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {FacadeService} from "../../shared/service-facade/facade.service";
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';

@Component({
  selector: 'app-status-tracker',
  templateUrl: './status-tracker.component.html',
  styleUrls: ['./status-tracker.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {displayDefaultIndicatorType: false},
    },
  ],
})
export class StatusTrackerComponent implements OnInit, OnDestroy {
  SectionStates = SectionStates;
  sectionStates: SectionStatus[];
  visibleSections$: Observable<SectionStatus[]>;
  isMobile$: Observable<boolean>;
  isLandingPage: boolean = false;
  selectedSection = "";
  destroySubject$: Subject<void> = new Subject();

  constructor(private statusTrackerService: SectionStatusService,
              private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer,
              private logger: NGXLogger,
              private coreService: CoreService,
              private _changeDetector: ChangeDetectorRef,
              private facadeService: FacadeService) {
    this.sectionStates = statusTrackerService.getStatusTrackerSections();
    this.selectedSection = this.sectionStates[0].description;
    this.visibleSections$ = this.statusTrackerService.statusTrackerSections$.pipe(
      takeUntil(this.destroySubject$),
      map(sections => sections.filter(section => section.visible))
    )

    this.matIconRegistry.addSvgIcon(
      'check_circle_outline',
      this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/check_circle_outline.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'check_circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/assets/check_circle.svg')
    );

    this.isMobile$ = this.facadeService.isMobile$;
  }

  /**
   * On Init of status tracker
   */
  ngOnInit(): void {
    this.statusTrackerService.sectionChange
      .pipe(takeUntil(this.destroySubject$),tap(
        (sectionStatus: SectionStatus) => {
          this.selectedSection = this.statusTrackerService.getSelectedSection();
          this.sectionStates = this.statusTrackerService.getStatusTrackerSections();
          let foundSection = this.sectionStates.find(s => s.section === sectionStatus.section);
          if (foundSection != null || foundSection != undefined) {
            this.logger.debug("Section status changed :" + sectionStatus.description + " Status:" + sectionStatus.status);
            foundSection.status = sectionStatus.status;
            foundSection.visible = sectionStatus.visible;
          }

          this._changeDetector.detectChanges();
        }
      ))
      .subscribe(
        async () => {
          await this._handleStepperTabIndex();
        }
      );

    this.coreService.pagePropsSubject.subscribe(props => {
      this.isLandingPage = props.isHomePage!;
      this._changeDetector.detectChanges();
    });

  }

  async ngAfterViewInit() {
    const removingElement: any = document.querySelectorAll('mat-stepper');
    const stepperHeaderElements: any = document.querySelectorAll('mat-step-header');
    const tabPanel: any = document.getElementsByClassName('mat-horizontal-content-container');
    // To remove mat-stepper - aria elements as per Allyant Team
    if(removingElement) {
      removingElement.forEach((ele: any) => {
        ele.removeAttribute('role');
        ele.removeAttribute('aria-orientation');
      })
    }
    //To remove mat-step-header - aria elements as per Allyant Team
    if(stepperHeaderElements) {
      stepperHeaderElements.forEach((headerElement: any) => {
        headerElement.removeAttribute('role');
        headerElement.removeAttribute('aria-selected');
        headerElement.removeAttribute('aria-posinset');
        headerElement.removeAttribute('aria-setsize');
        headerElement.removeAttribute('aria-controls');
      })
    }  
    //To remove role="tabpanel", aria labelledby and aria expanded attributes as per Allyant Team
    if (tabPanel) {
      Array.from(tabPanel).forEach((tab: any) => {
        Array.from(tab.children).forEach((child: any) => {
          child.removeAttribute('role');
          child.removeAttribute('aria-labelledby');
          child.removeAttribute('aria-expanded');
        });
      });
    }

    await this._handleStepperTabIndex();
  }

  async _handleStepperTabIndex() {
    const stepperHeaders: any = document.querySelectorAll('mat-step-header');
    if(stepperHeaders) {
      stepperHeaders.forEach((header: any) => {
        header.setAttribute('tabindex', '-1');
      })
    }
    const matIcon: any = document.querySelectorAll('mat-step-header span');
    matIcon.forEach((icon: any) => {
      if(icon.classList.contains('current-section')) {
        const parentHeader: any = icon.closest('mat-step-header');
        if(parentHeader) {
          parentHeader.setAttribute('tabindex', '0');
          parentHeader.setAttribute('aria-current', 'step');
        } else {
          parentHeader.setAttribute('tabindex', '-1');
        }
      }
    });
  }

  ngOnDestroy(): void {
      this.destroySubject$.next();
  }
}
